import { useLocation } from 'react-router-dom';

import t from '../../../text';
import { externalLinkGA } from '../../analytics';
import { REVIEWS_HREF } from '../../Constants';
import { BookingHeaderNav } from './BookingHeaderNav';
import { TrustPilotReviews } from './TrustPilotReviews';

const PREVIOUS_BOOKING_JOURNEY_URLS = ['/my-booking', '/login'];

export const HeaderBar = ({ openMyBookingModal }) => {
  const { pathname } = useLocation();
  const isInBookingJourney = pathname.includes('/booking/');
  const isInPreviousBookingJourney = PREVIOUS_BOOKING_JOURNEY_URLS.includes(pathname);
  const isInAnyBookingJourney = isInBookingJourney || isInPreviousBookingJourney;

  if (isInBookingJourney) return <BookingHeaderNav />;

  return (
    <div className="header-bar">
      {isInAnyBookingJourney ? (
        <a href={`tel:${t('header.cs.tel')}`} className="telephone">
          {t('header.cs.tel')}
        </a>
      ) : (
        <button onClick={openMyBookingModal} className="booking-button remove-button-styling cursor-pointer">
          {t('header.myBooking')}
        </button>
      )}

      <a
        href={REVIEWS_HREF}
        onClick={() => externalLinkGA(REVIEWS_HREF)}
        target="_blank"
        rel="noopener noreferrer text-reset"
      >
        <TrustPilotReviews />
      </a>
    </div>
  );
};
